<template>
  <a class="floating-container" :class="{ disabled: disabled }" @click="!disabled && $emit(`click`)">
    <div class="floating-button">
      <font-awesome-icon :icon="icon"/>
    </div>
  </a>
</template>
<script>
export default {
  name: 'FloatingActionButton',
  props : {
    icon : {
      type : String,
      required : false,
      default : 'add'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style scoped lang="scss">
.floating-container {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.floating-container .floating-button {
  width: 50px;
  height: 50px;
  background: var(--accent-primary);
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
  box-shadow: 0 4px 10px rgba(var(--accent-primary-rgb), 0.3);
  cursor: pointer;
  transition: var(--transition-default);

  &:hover {
    transform: var(--hover-scale);
    box-shadow: 0 6px 15px rgba(var(--accent-primary-rgb), 0.4);
  }
}

.floating-container.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.floating-container.disabled .floating-button {
  cursor: not-allowed;
  background: var(--text-secondary);
  box-shadow: 0 4px 10px rgba(var(--text-secondary-rgb), 0.2);
  transition: none;
  animation: none;

  &:hover {
    transform: none;
    box-shadow: 0 4px 10px rgba(var(--text-secondary-rgb), 0.2);
    animation: none;
  }
}
</style>